import getAllUrlParams from "./getUrlParams";

export const map = f => x => Array.prototype.map.call(x, f);

export const getOffset = element => {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top + document.body.scrollTop,
    left: rect.left + document.body.scrollLeft
  };
};

export const deepClone = object => {
  return JSON.parse(JSON.stringify(object));
};


export const getCookieValue = (key) => {
  const cookie = document.cookie.split(';').find(cookie => cookie.includes(key));
  return cookie ? cookie.split('=')[1] : null;
}


// A token is usable only when it is a non-empty string and not the serialized
// form of a missing value ("undefined" / "null").
export const isValidToken = (token) =>
  typeof token === 'string' && token !== '' && token !== 'undefined' && token !== 'null';

export const getRefreshToken = () => {
  const cookieValue = getCookieValue('refreshToken');
  const paramsValue = getAllUrlParams("refreshToken");
  const value = cookieValue || paramsValue || localStorage.getItem('refreshToken');
  // Return null instead of "undefined"/"null" so the API is never called with an invalid token.
  return isValidToken(value) ? value : null;
}
